import React from 'react';
import { Box, Typography } from '@mui/material';
import { VideoLibraryOutlined as VideoLibraryOutlinedIcon } from '@mui/icons-material';

export interface EvidenceCountProps {
  count?: number | null;
  caption?: string;
  /** When set, replaces the default “N clip(s)” line (queue semantic labels). */
  primaryText?: string;
}

const EvidenceCount: React.FC<EvidenceCountProps> = ({ count, caption, primaryText }) => {
  const value = Math.max(0, Number(count || 0));
  const mainLine =
    primaryText ||
    `${value} ${value === 1 ? 'clip' : 'clips'}`;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          width: 30,
          height: 30,
          borderRadius: 1.5,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#edf4fb',
          color: '#275785',
        }}
      >
        <VideoLibraryOutlinedIcon sx={{ fontSize: 18 }} />
      </Box>
      <Box sx={{ lineHeight: 1.1 }}>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {mainLine}
        </Typography>
        {caption && (
          <Typography variant="caption" color="text.secondary">
            {caption}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default EvidenceCount;
